import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateAccountComponent } from './account/create-account.component';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CompletedComponent } from './completed/completed.component';
import { AuthGuard } from './home/auth-guard.service';
import { WelcomeComponent } from './home/welcome.component';
import { LoginComponent } from './login/login.component';
import { PasswordResetComponent } from './login/passwordreset.component';
import { ValidateResetComponent } from './login/validatekey.component';
import { ProductDetailComponent } from './products/product-detail.component';
import { ProductListComponent } from './products/product-list.component';
import { SeamlessAuthComponent } from './seamlessauth/seamlessauth.component';
import { AlreadyLoggedInGuard } from './home/loggedin-auth-guard.service';

const routes: Routes = [
  { path: 'home/from/:id', component: WelcomeComponent },
      { path: 'shop/from/:id', component: ProductListComponent },
      { path: 'detail/from/:id:prodId', component: ProductDetailComponent },
      { path: 'seamless/from/:id', component: SeamlessAuthComponent },
      { path: 'createAccount/from/:id', component: CreateAccountComponent, canActivate: [AlreadyLoggedInGuard] },
      { path: 'checkout/from/:id', component: CheckoutComponent, canActivate: [AuthGuard] },
      { path: 'completed/from/:id', component: CompletedComponent, canActivate: [AuthGuard] },
      { path: 'reset/from/:id', component: PasswordResetComponent },
      { path: 'validate/for/:id:key', component: ValidateResetComponent },
      { path: 'login', component: LoginComponent, canActivate: [AlreadyLoggedInGuard] },
      { path: 'cart/from/:id', component: CartComponent },
      { path: '', redirectTo: 'shop/from/:id', pathMatch: 'full' },
      { path: '**', redirectTo: 'shop/from/:id', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
